import { NavigationItem } from '.'

import { RoutingPaths } from 'app/routes/routes'

import { AllIcons } from 'shared/ui/app-icon/types'

export const NavigationItems: NavigationItem[] = [
  {
    id: 'home',
    icon: AllIcons.PLANE_NEW,
    translationKey: 'main',
    path: RoutingPaths.path(),
    isNew: false,
  },
  {
    id: 'orders',
    icon: AllIcons.TICKET_ALT,
    translationKey: 'my_orders',
    path: RoutingPaths.myOrders.path(),
    isNew: false,
  },
  {
    id: 'favorites',
    icon: AllIcons.FAVORITES,
    translationKey: 'favorites',
    path: RoutingPaths.avia.favorites.path(),
    isNew: true,
  },
  {
    id: 'profile',
    icon: AllIcons.CIRCLE_USER,
    translationKey: 'profile',
    path: RoutingPaths.profile.path(),
    isNew: false,
  },
]
